import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { MrpContainerSizeContainer } from '../../../../../../models/aggregates/mrp-packing';
import { ApiVisa, Pagination } from '../../shared';
import { ApiResponseModel } from '../../shared/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class MrpContainerSizeService extends BaseApiTemplateService<MrpContainerSizeContainer> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MRP_PREFIX + "bl-mrp-container-sizes/" + Core2Config.BACKOFFICE_EP_SUFFIX;
  readonly clean_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MRP_PREFIX + "bl-mrp-container-sizes/";

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX
      + Core2Config.MRP_PREFIX + "bl-mrp-container-sizes/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.MRP_PREFIX
      + "bl-mrp-container-sizes/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

  getDrumRecommendation(pagination: Pagination, visa: ApiVisa) {
    if (visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.clean_path + "get-drum-recommendation-for-coils";
    }
    const UrlByCriteria = this.apiUrl + '?' + pagination.getQueryKeyValues();
    return this.httpClient.get<ApiResponseModel<MrpContainerSizeContainer>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

}
